/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    JiraStatusSync,
    JiraStatusSyncFromJSON,
    JiraStatusSyncToJSON,
} from './';

/**
 * 
 * @export
 * @interface Jira
 */
export interface Jira {
    /**
     * 
     * @type {string}
     * @memberof Jira
     */
    cloudId: string;
    /**
     * 
     * @type {string}
     * @memberof Jira
     */
    cloudName?: string;
    /**
     * 
     * @type {string}
     * @memberof Jira
     */
    projectKey: string;
    /**
     * 
     * @type {string}
     * @memberof Jira
     */
    projectName?: string;
    /**
     * 
     * @type {string}
     * @memberof Jira
     */
    createWithCategoryId: string;
    /**
     * 
     * @type {string}
     * @memberof Jira
     */
    initialStatusId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Jira
     */
    createWithTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Jira
     */
    issueTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Jira
     */
    autoCreateIssue?: boolean;
    /**
     * 
     * @type {JiraStatusSync}
     * @memberof Jira
     */
    statusSync?: JiraStatusSync;
    /**
     * 
     * @type {boolean}
     * @memberof Jira
     */
    responseSync?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Jira
     */
    commentSync?: boolean;
}

export function JiraFromJSON(json: any): Jira {
    return {
        'cloudId': json['cloudId'],
        'cloudName': !exists(json, 'cloudName') ? undefined : json['cloudName'],
        'projectKey': json['projectKey'],
        'projectName': !exists(json, 'projectName') ? undefined : json['projectName'],
        'createWithCategoryId': json['createWithCategoryId'],
        'initialStatusId': !exists(json, 'initialStatusId') ? undefined : json['initialStatusId'],
        'createWithTags': !exists(json, 'createWithTags') ? undefined : json['createWithTags'],
        'issueTypeId': !exists(json, 'issueTypeId') ? undefined : json['issueTypeId'],
        'autoCreateIssue': !exists(json, 'autoCreateIssue') ? undefined : json['autoCreateIssue'],
        
        'statusSync': !exists(json, 'statusSync') ? undefined : JiraStatusSyncFromJSON(json['statusSync']),
        'responseSync': !exists(json, 'responseSync') ? undefined : json['responseSync'],
        'commentSync': !exists(json, 'commentSync') ? undefined : json['commentSync'],
    };
}

export function JiraToJSON(value?: Jira): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'cloudId': value.cloudId,
        'cloudName': value.cloudName,
        'projectKey': value.projectKey,
        'projectName': value.projectName,
        'createWithCategoryId': value.createWithCategoryId,
        'initialStatusId': value.initialStatusId,
        'createWithTags': value.createWithTags,
        'issueTypeId': value.issueTypeId,
        'autoCreateIssue': value.autoCreateIssue,
        
        'statusSync': JiraStatusSyncToJSON(value.statusSync),
        'responseSync': value.responseSync,
        'commentSync': value.commentSync,
    };
}


